//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';
import { fromBase64 } from '@razlet/utils';
import LoginRequest from '~/api/requests/auth/login';
import UserMethods from '~/api/methods/auth';

export default {
  name: 'auth-login-form',
  data () {
    return {
      request: new LoginRequest(),
      sender: new UserMethods(),
      pending: false,
      error: null,
    };
  },
  computed: {
    backPath () {
      if (!this.$route.query || !this.$route.query.path) return '';
      return fromBase64(decodeURIComponent(this.$route.query.path));
    },
  },
  methods: {
    ...mapActions(['getUser']),
    login () {
      if (this.pending) return;
      // Some password managers fill the DOM without updating Vue's model.
      this.request.email = this.$refs.email.getValue();
      this.request.password = this.$refs.password.getValue();
      this.error = null;
      this.pending = true;
      return this.sender.login(this.request)
        .then(response => {
          if (response.data.error) this.error = response.data.error.message;
          else if (response.data.success) {
            return this.getUser().then(() => {
              // eslint-disable-next-line no-console
              console.info(`user: ${this.user.profile.contractor.name}`);
              const path = this.isCabinet
                ? this.user.isAllowed('shipment.create') ? '/pricing' : '/accreditations'
                : '/';
              const navigation = this.$router.push(this.backPath || path);
              this.$bus.$emit('login');
              this.$bus.$emit('login-no-event');
              return navigation;
            });
          } else {
            this.error = 'Ошибка аутентификации';
          }
        })
        .catch(() => {
          this.error = 'Ошибка аутентификации';
        })
        .finally(() => {
          this.pending = false;
        });
    },
  },
};
